/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'ep-migration-inapp-1736': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--ep-migration-inapp-1736/placements/in-app/screen-space-flags/render'
			),
	),
	'ep-migration-inapp-1737': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--ep-migration-inapp-1737/placements/in-app/screen-space-flags/render'
			),
	),
	'ep-migration-jira-ops-team-heartbeats': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--ep-migration-jira-ops-team-heartbeats/placements/in-app/screen-space-flags/render'
			),
	),
};
